import { ContainerModule } from "inversify";
import * as Api from "@/app/interaction/api";
import * as SerializationApi from '@/app/state-serialization/api';
import AdmonitionComponent from "./admonition-component.vue";
import { AdmonitionStateProtobufSerializer } from "./admonition-state-protobuf-serializer";
import { IncludeAdmonitionHandler } from './include-admonition-handler'

export const admonitionFactoryModule = new ContainerModule(bind => {
  bind<Api.InteractiveComponentPlugin>(Api.InteractiveComponentPluginSymbol)
    .toConstantValue(AdmonitionComponent)
    .whenTargetNamed("admonition");

  bind<Api.IncludeComponentsHandlerInterface>(Api.IncludeComponentsHandlerSymbol).to(IncludeAdmonitionHandler);

  bind(SerializationApi.StateSerializationPluginSymbol).to(AdmonitionStateProtobufSerializer)
});
